export const ARTICLE_SORT_FIELDS = ['id', 'title', 'createAt', 'updateAt'] as const;
export type ArticleSortField = typeof ARTICLE_SORT_FIELDS[number];

export interface Article {
  id: number;
  title: string;
  content: string;
  createAt: string | null;
  updateAt: string | null;
}

export interface ArticlePage {
  currentPage: number;
  totalPages: number;
  pageSize: number;
  totalElements: number;
  data: Article[];
}

export interface ArticleQuery {
  page: number;
  size: number;
  sort: ArticleSortField;
}

export interface CreateArticleInput {
  title: string;
  content: string;
}

export interface UpdateArticleInput {
  title?: string;
  content?: string;
}
